<template>
	<div id="appbox">
		<div class="top">
			<img src="../../../static/img/jylogo.png" alt="" style="position: absolute;top: 32px;left: 40px;width: 225px;height: 80px;object-fit: contain;" @click="gohome">
			<div class="nav" style="font-size: 24px;font-family: 'Courier New', Courier, monospace;text-shadow: 2px 2px 4px rgba(46,41,41,.6);">
				<div class="nav_box" @click="gohome" >首页</div>
				<div class="nav_box" @click="gocamp" >基地信息</div>
				
				<div class="nav_box" :class="(category_id==item.id ?' active_nav':'')"     @click="checktype(item.id)" v-for="(item,index) in colCate" v-bind:key="index"  >{{ item.title }}</div>
				<!-- :style="{ color: category_id==item.id ? '#000' : '' }" -->
				<!-- <div :style="{category_id==item.id ? ' color: #000' : '' }"></div> -->
			</div> 
		<div class="search" style="margin-top: 15px;">
			<el-input v-model="keyword" placeholder="请输入产品名称名称" ></el-input>
			<el-button type="warning" color="#FE7C2B" icon="el-icon-search" @click="handleSearch"></el-button>
		</div>
		</div>
			
		<div class="main_box" :style="screenWidth>785?'':'width:100%;'">
			<div class="screen_box" v-if="screenWidth>785">
				<div class="screen_items" >
					<div class="screen_title_box">
						<div class="screen_title" >
							产品标签：
						</div>
					</div>
					<div class="" style="width: 980px;display: flex;flex-wrap: wrap;" >
						<div  v-for="item in addresstype" :key="item"  :class="item.id==area_type?'screen_item_a':'screen_item'"  @click="themetab(item.id)" >
							{{item.title}}
						</div>
					</div>
				</div>
				<div class="screen_items" v-if="areaoptions.length!=0">
					<div class="screen_title_box">
						<div class="screen_title" >
							区域：
						</div>
					</div>
					<div class="" style="width: 980px;display: flex;flex-wrap: wrap;" >
						<div  v-for="item in areaoptions" :key="item"  :class="item.aid==area_code?'screen_item_a':'screen_item'"  @click="checkarea(item.aid)" >
							{{item.atitle}}
						</div>
					</div>
				</div>
				<div class="screen_items" >
					<div class="screen_title_box">
						<div class="screen_title" >
							行程天数：
						</div>
					</div>
					<div class="" style="width: 980px;display: flex;flex-wrap: wrap;" >
						<div  v-for="item in daysumopt" :key="item"  :class="item.id==day_num?'screen_item_a':'screen_item'"  @click="checkdaynum(item.id)" >
							{{item.title}}
						</div>
					</div>
				</div>
				
			</div>
		
			<div class="course_box" :style="screenWidth>785?'':'width:100%; justify-content: center;'">
				<div class="coures_item" v-for="item in camplist" :key="item"  @click="detail(item.id)"  >
					<div class="coures_item_icon">
						<img :src="item.cover" alt="" srcset="">
						
					</div>
					<div class="coures_item_title">
						{{item.title}}
					</div>
					<div class="coures_item_msg">
						
						<div class="">
							<span >{{item.category}}</span>
						</div>
					</div>
					
					<div class="coures_item_tags">
						<div class="campitem_tag" v-for="tag in item.tags" :key="tag" :style="'color:'+tag.color+';background:'+tag.background+';'" >
							{{tag}}
						</div>
					</div>
				</div>
				<div class="pages_total">
					<el-pagination
					  background
					  :page-size="12"
					  :small="screenWidth<785"
					  :pager-count="screenWidth>785?7:5"
					  :hide-on-single-page="true"
					  @current-change="pagechange"
					  layout="total, prev, pager, next"
					  :total="total">
					</el-pagination>
				</div>
				<div v-if="camplist.length==0" style="display: flex;justify-content: center;flex-direction: column;margin: 0 auto;">
					<img src="https://review-1254115215.cos.ap-beijing.myqcloud.com/20251128/d0e8cca4e20fae74b88a3ac53648fdf6.png" alt="">
					<div>暂无产品</div>
				</div>
			</div>
		</div>
		<div :class="tops?'navbar':'navbar-top'"  v-if="screenWidth>785">
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				
			
				<!-- <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a> -->
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		   
			
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		<!-- footer -->
		<!-- <div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;padding-top:20px;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="item in bottomnav" :key="item" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="item in bottomnav" :key="item" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
			<div class="row" :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'" >
			
				
				<div class="copy-left " :style="screenWidth>785?'':'width:40%;'" >
					<div class="bottom_logo"  v-if="screenWidth>785" >
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					
				</div>
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'" abort="">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
		 -->
		
	</div>
</template>

<script>
	import {  getNewslist, getPac, getCourselist, getPc, getPlate,getbottomnav ,getcolCate,getproductlist,getCategory} from '@/request/api'
	
	export default {
	  name: "Courselist",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			  bottomnav:[],
				top_search_url:'/Courselist',
				tags_type:0,
				manage_url:'/',
				manageoptions:[
					{
					  value: '/',
					  label: '管理入口'
					}, {
					  value: 'https://yxwy.wanjiaxiao.cn/',
					  label: '机构管理后台'
					},
					 {
						value:'http://xh.wanjiaxiao.cn/seeyon/index.jsp',
						 label: '研学OA平台'
					 }
				],
				stitle:'',
				options: [{
				          value: '/Courselist',
				          label: '课程搜索'
				        }],
				platelist:[],
				activeIndex2: '/Courselist',
				phoneboxshow:false,
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				logintype:true,
				banner:[
				],
				camptypes:[
					{ text: '全部', value: 0 },
					{ text: '基地', value: 2 },
					{ text: '营地', value: 1 },
				],
				categorytypes:[],
				vancategorytypes:[],
				periodtypes:[],
				vanperiodtypes:[],
				
				themelist:[],
				vanthemelist:[],
				theme_id:0,
				camptype:0,
				camplist:[],
				quicklist:[],
				aclist:[],
				newsiconon:'',
				// 分类的id
				category_id:0,
				period:0,
				total:0,
				page_index:1,
				uuid:'',
				newsdata:{},
				pcsetdata:{},
				modules:'',
				showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
				tops:false,
				heights:window.innerHeight,
				scrolltop:'',
				//屏幕宽高
				// 屏幕宽度
				screenWidth: window.innerWidth,
				top_bannerWidth:Math.round(window.innerWidth/3.42),
				// 屏幕高度
				screenHeight: window.innerHeight,
				//手机端导航栏
				vannavshow:false,
				vannavlist:[
					{
						link:'/Home',
						text:'研学首页'
					},
					{
						link:'/Camplist',
						text:'营地列表'
					},
					{
						link:'/Newslist',
						text:'资讯资讯'
					},
					{
						link:'/Baselist',
						text:'基地列表'
					},
					{
						link:'/Activitylist',
						text:'研学活动'
					},
					{
						link:'/Linelist',
						text:'研学线路'
					},
					
					{
						link:'/mentorlist',
						text:'研学导师'
					},
					{
						link:'/expertlist',
						text:'专家团队'
					},
				],
				colCate:[],
				// 产品名称查询关键词
				keyword:'',
				// 区内还是国内
				addresstype:[],
				area_type:'',
				// 具体的地区
				areaoptions:[],
				area_code:"",
				daysumopt:[
					{title:'全部',id:0},
					{title:'1日',id:1},
					{title:'2日',id:2},
					{title:'3日',id:3},
					{title:'4日',id:4},
					{title:'5日',id:5},
					{title:'6日',id:6},
					{title:'7日',id:7},
					{title:'7日以上',id:8},
					
				],
				day_num:''

		      }
	  },
	  beforeCreate(){
	  	//    const loading = this.$loading({
	  	//             lock: true,
	  	//             text: '页面载入……',
	  	//             // spinner: 'el-icon-loading',
	  	//             background: '#ffffff'
	  	//           });
	  },
	  created() {
		// this.getpcset()  
	  },
	  mounted() {
		//   const { stitle } = this.$route.query;
		console.log("query",this.$route.query)
		//   this.stitle = stitle||''
		   window.addEventListener('resize', this.handleResize, true)
		  var token = localStorage.getItem('token')||''
		  this.token=token
		//   this.getPlate()
		//    this.getbottomnav()
		   this.category_id = this.$route.query.category_id;
		  	
			this.getlist()
			// this.gettypes()

			this.getcolCate()
			this.getCategory()
	  window.addEventListener('scroll', this.scrollToTop)
	  		
	  },
	   destroyed () {
	          window.removeEventListener('scroll', this.scrollToTop)
	    },
	  // 销毁监听
	  		beforeDestroy() {
	  		  window.removeEventListener('resize', this.handleResize);
	  		},
	  methods: {
		// 切换行程天数
		checkdaynum(e){
			this.day_num=e
			this.getlist()
		},
		gocamp(){
			this.$router.push({
				name:'/Camplist',
				path:'/Camplist',
			})
			
		},	
		// 切换地区
		checkarea(e){
			this.area_code=e
			this.getlist()
		},
		// 获取区内国内具体的
		getCategory(){
			var data={
				organ_id:13
			}	
			getCategory(data).then(res=>{
					if (res.data.code == 200) {
					this.addresstype=res.data.data.right
					console.log("基地1",this.addresstype)
				}
			})
		},
		// 产品名称关键字查询
		handleSearch(){
			this.page_index=1
			this.getlist()
		},	
		// 切换产品分类
		checktype(e){
			this.category_id=e
			this.getlist()
		},
		getcolCate(){
				var data={
					organ_id:13
				}
				getcolCate(data).then(res => {
				if (res.data.code == 200) {
					this.colCate=res.data.data.left
					console.log("基地",this.colCate)
				}
				// loading.close();
			})
		},
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
	  		  vanlinkgo(e){
	  		  		  console.log(e)
	  		  		  this.$router.push({
	  		  		    path: e.link,
	  		  		    name: e.link,
	  		  		    query: {
	  		  		    }
	  		  		  }); 
	  		  },
	  		  vannavmenushow(){
	  		  		this.vannavshow=false  
	  		  },
	  		  handleResize() {
	  		  		   this.top_bannerWidth = 0;
	  		    this.screenWidth = window.innerWidth;
	  		  		this.top_bannerWidth=window.innerWidth/3.42
	  		  		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
	  		    this.screenHeight = window.innerHeight;
	  		  },
		  getbottomnav(){
		  		  var data={
		  			  page_index:1,
		  			  page_size:15,
						flag:99
		  		  }
		  		getbottomnav(data).then(res=>{
		  			this.bottomnav=res.data.data.list
		  		})  
		  },
		  gobottomnav(type,link){
		  		  if(type==1){
		  			  this.$router.push({
		  			  	path:link
		  			  });
		  		  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  logout(){
		  			  var that=this
		  			  this.$confirm('是否确认退出登录?', '提示', {
		  			  					confirmButtonText: '确定',
		  			  					cancelButtonText: '取消',
		  			  					type: 'warning'
		  			  }).then(() => {
		  						this.$alert("已退出登录", '', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								localStorage.setItem('token', '')
		  								localStorage.setItem('refreshToken', '')
		  								 that.$router.go(0)
		  							}
		  						  });
		  			  }).catch(() => {
		  			  		 
		  			  });
		  },
		  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		  			  this.showserviceQR=true
		  },
		  hideserviceQRCode(){//隐藏二维码
		      this.showserviceQR = false
		  },
		  showQRCode(){//显示二维码
		          this.showQR = true
		      },
		      hideQRCode(){//隐藏二维码
		          this.showQR = false
		      },
		      scrollToTop () {
		          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		          this.scrolltop = scrollTop
		          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		              this.tops = true
		          } else {
		              this.tops = false
		          }
		      },
		      gotop () {
		          let timer = setInterval(() => {
		              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		              if (this.scrolltop === 0) {
		                  clearInterval(timer)
		              }
		          }, 15)
		      },
		  showstep(ind) {
		       this.$refs.carousel.setActiveItem(ind)
		     },
		  		  goplate(id){
		  			  this.modules=id
		  			  this.page_index=1
		  			  this.getlist()
		  		  },
		  getPlate(){
		  		var data={
					flag:99
		  		}  
		  		getPlate(data).then(res=>{
		  			this.platelist=res.data.data
		  		})
		  },
		  showphonebox(){
		  		this.phoneboxshow=true  
		  },
		  closephonebox(){
		  		this.phoneboxshow=false  
		  },
		  goregister(e){
		  			  this.$router.push({
		  			    path: "/register",
		  			    name: "/register",
		  			  		  query: {
		  			  		  }
		  			  });
		  },
		  gohome(e) {
		    this.$router.push({
		      path: "/Home1",
		      name: "/Home1",
		  			  query: {
		  			  }
		    });
		  },
	  		  getpcset(){
				var data={
				flag:99
			}
	  		  		getPc(data).then(res=>{
	  		  			this.pcsetdata=res.data.data
	  		  		})  
	  		  },
			  themetab(val){
			  	this.area_type=val
				console.log("类型11",val)
				this.addresstype.forEach(item=>{
					if(item.id==val){
						this.areaoptions=item.data
					}
				})
			  	this.getlist()
			  },
		  camptypetab(val){
			  this.category_id=val
			  this.getlist()
		  },
		  periodtab(val){
			  this.period=val
			  this.getlist()
		  },
		  pagechange(val){
			this.page_index=val
			this.getlist()
		  },
		  getlist(){
			var data={
				page_index: 1,
				page_size: 10,
				organ_id:13,
				category_id:this.category_id,
				area_code: this.area_code,
				area_type: this.area_type,
				day_num:this.day_num,
				keyword:this.keyword,
				supplier_id:"" ,
			}  
			getproductlist(data).then(res=>{
				
				this.camplist=res.data.data.list
				console.log("基地",this.camplist)
				this.total=res.data.data.total
				
			}).catch(error => {
				console.error(error);
			});
		  },
		//   handleClick(e){
		// 		console.log(e,this.category_id)
		// 		 this._getNewslist()
		//   },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			var data={}
			getPac(data).then(res=>{
				console.log(res.data)
				this.categorytypes=res.data.data.cat
				this.periodtypes=res.data.data.res
				this.themelist=res.data.data.the
				var vancategorytypes=[]
				var vanperiodtypes=[]
				var vanthemelist=[]
				for(var cat of res.data.data.cat){
					vancategorytypes.push({
						text:cat.title,
						value:cat.id
					})
				}
				this.vancategorytypes=vancategorytypes
				for(var resv of res.data.data.res){
					vanperiodtypes.push({
						text:resv.title,
						value:resv.id
					})
				}
				this.vanperiodtypes=vanperiodtypes
				for(var the of res.data.data.the){
					vanthemelist.push({
						text:the.title,
						value:the.id
					})
				}
				this.vanthemelist=vanthemelist
				const loading = this.$loading({
				         lock: true,
				         text: 'Loading',
				         spinner: 'el-icon-loading',
				         background: 'rgba(0, 0, 0, 0.7)'
				       });
				loading.close();
				// this.category_id=res.data.data.cat[0].id
				// this.getlist()
			}).catch(error => {
			  console.error(error);
			});
		  },
		  /*
		   * 查看详情
		   * */
		detail(e) {
		    this.$router.push({
		      path: "/CourseDetails",
		      name: "CourseDetails",
		      query: {
		        id: e
		      }
		    });
		},
		gomodules(e){
			if(e){
				window.location.href = e;
			}
		},
	  }
	};
</script>

<style scoped>
.active_nav{
	color: #000;
	text-shadow: none;
}
	.pages_total{
		width: 100%;
		display: flex;
		justify-content: center;
	}
	.screen_scroll{
		width: 61px;
		height: 980px;
		 position: relative;
		  overflow: auto;
		  transform-origin: 0 0;
		    transform: translateY(61px) rotate(-90deg);

	}
	.screens_content{
		width: 980px;
		 position: absolute;
		  left: 100%;
		  transform-origin: 0 0;
		  transform: rotate(90deg);
		  display: flex;
	}
	.screen_scroll::-webkit-scrollbar {
  width: 0;
}

	.screens_box{
		width: 980px;
		height: 61px;
		/* overflow-x: scroll; */
		display: flex;

	}
	.course_box{
		display: flex ;
		flex-wrap: wrap;
		width: 100%;
		margin-top: 20px;
		justify-content: start;
		
	}
	.coures_item{
		width: 32%;
		min-height: 314px;
		margin: 0px 0px 24px 0;
		border-radius: 4px;
		margin-right: 0.5%;
		margin-left: 0.5%;
		background: #ffffff;
		
	}
	.coures_item:hover{
		box-shadow: 0 3px 20px rgba(200, 120, 0, 0.8);
	}
	.coures_item_icon{
		position: relative;
		height: 237px;
		overflow: hidden;
	}
	.coures_item_icon img{
		width: 100%;
		height: 100%;
		-webkit-transform: scale(1);
		transform: scale(1);
		-webkit-transition: all .3s;
		transition: all .3s;
		padding: 8px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		border-radius: 12px;
/* 		-o-object-fit: scale-down;
		object-fit: scale-down; */
	}
	.coures_item_type{
		
		display: flex;
		justify-content: flex-end;
		flex-wrap: wrap-reverse;
		
		
	}
	.coures_item_type span{
		display: block;
		
		margin: 0 5px 5px 0;
		
		font-size: 12px;
		padding: 2px 10px;
		
    color: #FE7C2B;
    background-color: #FE7C2B12;
	}
	.coures_item_title{
		font-size: 17px;
		min-height: 0px;
		height:15px;
		margin-bottom: 10px;
		width: 324px;
		padding: 8px;
		color: #333;
		text-align: left;
		/* text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2; */
		display: -webkit-box;
    	-webkit-box-orient: vertical;
    	-webkit-line-clamp: 1;
    	text-overflow: ellipsis;
    	overflow: hidden;
	}
	.coures_item_msg{
		padding: 0px 8px;
		text-align: left;
		color: #999;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
	}
	.coures_item_tags{
		display: flex;
		/* width: 100%; */
		padding: 8px;
		justify-content: flex-end;
		
	}
	.campitem_tag{
		width: 70px;
		height: 30px;
		/* margin: 5px; */
		font-size: 12px;
		line-height: 30px;
		color: #FE7C2B;
    	background-color: #FE7C2B12;
	}
	
	
	.screen_box{
		margin-top: 30px;
		background: #fff;
		border: 1px solid #e9e9e9;
		border-bottom: 0;
		width: 100%;
		box-shadow: 0 2px 18px 0 rgba(0,0,0,.1);
	}
	.screen_items{
		width: 1100px;
		display: flex;
		flex-wrap: wrap;
		/* white-space: nowrap; */
		align-items: flex-start;
		/* overflow: scroll;   */
		overflow: auto;
		      white-space: nowrap;
		overflow-x: auto;
		overflow-y: hidden;
		
		/* padding-left: 134px; */
		

		border-bottom: 1px solid #e9e9e9;
		
	}
	.screen_items::-webkit-scrollbar {
		display: none;
	}
	.screen_title_box{
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
	}
	.screen_title{
		width: 120px;
		padding: 19px 0;
		text-align: center;
		background: #f4f4f4;
		flex-shrink: 0;
		flex-basis: auto;
		flex-grow: 0;
		display: inline-block;
	}
	.screen_item{
		width: 100px;
		margin: 13px 0 13px 15px;
		cursor: pointer;
		height: 34px;
		line-height: 34px;
		text-align: center;
		flex-shrink: 0;
		flex-basis: auto;
		flex-grow: 0;
		display: inline-block;
	}
	.screen_item_a{
		width: 100px;
		margin: 13px 0 13px 15px;
		cursor: pointer;
		    height: 34px;
		    line-height: 34px;
		text-align: center;
		    background: #FE7C2B;
		    color: #fff;
			flex-shrink: 0;
			flex-basis: auto;
			flex-grow: 0;
			display: inline-block;
			
	}
	.screen_item:hover{
		background: #FE7C2B;
		color: #fff;
	}
	
</style>